import { useIntl } from 'react-intl';

import { Option } from '@/scenarios/legacy-player/components/PlayerSkin/parts/OptionList';

export const AUTO_QUALITY_VALUE = 'auto';

export const useAutoQualityOption: () => Option<string | 'auto'> = () => {
    const intl = useIntl();
    return {
        name: intl.formatMessage({
            id: 'components.PlayerSkin.06b9281e396db002010bde1de57262eb',

            defaultMessage: 'Auto',
            description: 'Настройка "Авто" в настройках плеера',
        }),
        value: AUTO_QUALITY_VALUE,
        isInlineNote: true,
    };
};
